import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "@phosphor-icons/react";

const KEY = "altin_cookie_consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const stored = localStorage.getItem(KEY);
    if (!stored) {
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
  };

  if (location.pathname.startsWith("/admin")) return null;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          data-testid="cookie-consent"
          className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[60]"
        >
          <div className="bg-altin-ink text-white border border-altin-gold/30 shadow-2xl p-6">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 grid place-items-center border border-altin-gold/40 text-altin-gold shrink-0">
                <Cookie size={20} weight="light" />
              </div>
              <div>
                <h3 className="font-serif-display text-xl tracking-tight">
                  We value your privacy
                </h3>
                <p className="mt-2 text-sm text-white/70 leading-relaxed">
                  We use cookies to enhance your browsing experience and analyse
                  site traffic. By continuing you consent to our use of cookies.
                  Read our{" "}
                  <Link
                    to="/cookie-policy"
                    className="text-altin-gold underline underline-offset-2"
                  >
                    Cookie Policy
                  </Link>
                  .
                </p>
                <div className="mt-5 flex flex-wrap gap-3">
                  <button
                    data-testid="cookie-accept"
                    onClick={() => decide("accepted")}
                    className="bg-altin-gold text-altin-ink px-5 py-2.5 text-xs tracking-[0.2em] uppercase hover:bg-altin-goldHover transition-colors"
                  >
                    Accept All
                  </button>
                  <button
                    data-testid="cookie-reject"
                    onClick={() => decide("rejected")}
                    className="border border-white/25 text-white px-5 py-2.5 text-xs tracking-[0.2em] uppercase hover:border-altin-gold hover:text-altin-gold transition-colors"
                  >
                    Reject Non-Essential
                  </button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
